import { Dialog, DialogContent, DialogContentText } from '@mui/material'
import React, { useState } from 'react'
import Viewsubmission from '../../Viewsubmission/Viewsubmission'

const Tempfile = ({data}) => {

    const [opensecond, setopensecond] = useState(false);
  return (
    <div>
             

    <Dialog open={opensecond} onClose={() => setopensecond(false)}>
    <div className="PopUpTopSection">
    <h6 className="PopupTitleHeading"></h6>  
    <button className="CancelButtton" onClick={() => setopensecond(false)}>X</button>
    </div>
      <DialogContent>
        <DialogContentText>
         <Viewsubmission formid={data.formId} submissionid={data.submissionId}/>
        </DialogContentText>
      </DialogContent>               
    </Dialog>
    <span className="AddNewRecord" onClick={() => setopensecond(true)}> {data.applicationStatus == "Resubmit"?"Edit":"view"}</span>
  </div>
  )
}

export default Tempfile